<template>
	<div>
		<div class="exam-top">
			<div><img src="../../assets/exam/login.png" /></div>
		</div>
		<div class="conts">
			<div class="conts-img">
				<img v-if="getGradelist.is_pass_switch==1" src="../../assets/exam/Successful.png" />
				<img v-else src="../../assets/exam/Notpass.png" />
			</div>
			<div class="conts-tips" style="color: #1DC33C;" v-if="getGradelist.is_pass_switch==1">恭喜你</div>
			<div class="conts-tips" style="color: #F7B500;" v-else>很遗憾</div>
			<div class="tis" v-if="getGradelist.is_pass_switch==1">恭喜您考试通过，快去查看您的证书吧！</div>
			<div class="tis" v-else>很遗憾您考试未通过，再次继续努力！</div>
			<div class="conts-content">
				<el-row>
					<el-col :span="20">
						<div class="one">
							<!-- <div>兰州市属企业专业技术人员继续教育考试</div> -->
							<div>用时：{{getGradelist.time}}分钟</div>
							<div>答对题数：{{getGradelist.correct}}题</div>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="two" v-if="getGradelist.is_pass_switch==1">{{getGradelist.grade}}分</div>
						<div class="two" style="color: #F7B500;" v-else>{{getGradelist.grade}}分</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="buts" style="background:#0662B3 ;" v-if="getGradelist.is_pass_switch==1" @click="next()">
			查看证书
		</div>
		<div class="buts" v-else @click="back()">
			我要补考
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				getGradelist: {}
			}
		},
		created() {
			var id = this.$route.query.id
			this.getGrade(id)
		},
		methods: {
			//获取考试结果
			getGrade(id) {
				this.$http({
						method: 'GET',
						url: 'Exam/getGrade?id=' + id,
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.getGradelist = response.data
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			//查看证书
			next() {
				this.$router.push({
					path: "/certificate",
				})
			},
			//补考
			back() {
				this.$router.push({
					path: "/examination",
				})

			}

		}
	}
</script>

<style lang="scss" scoped>
	.exam-top {
		width: 100%;
		height: 88px;
		background-image: url('../../assets/exam/bj.png');
		background-size: 100% 88px;

		div {
			width: 1300px;
			margin: 0 auto;
			padding-top: 4px;

			img {
				width: 650px;
				height: 79px;
			}
		}
	}

	.conts {
		width: 844px;
		height: 397px;
		margin: 130px auto;

		.conts-img {
			width: 127px;
			height: 102px;
			margin: 0 auto;

			img {
				width: 127px;
				height: 102px;
			}
		}

		.conts-tips {
			text-align: center;
			height: 22px;
			font-size: 20px;
			font-weight: bold;
			margin-top: 20px;
		}

		.tis {
			text-align: center;
			height: 32px;
			font-size: 22px;
			font-weight: 400;
			color: rgba(0, 0, 0, 0.25);
			line-height: 33px;
			margin-top: 10px;
		}

		.conts-content {
			width: 844px;
			height: 133px;
			margin-top: 45px;
			background: rgba(0, 74, 193, 0.05);

			.one {
				margin-left: 16px;

				div {
					&:nth-child(1) {
						height: 31px;
						padding-top: 28px;
						font-size: 24px;
						font-weight: 400;
						color: #4C556B;
					}

					&:nth-child(2) {
						margin-top: 22px;
						height: 18px;
						font-size: 18px;
						font-weight: 400;
						color: #434B5F;
					}

					&:nth-child(3) {
						margin-top: 25px;
						height: 18px;
						font-size: 18px;
						font-weight: 400;
						color: #434B5F;
					}
				}
			}

			.two {
				font-size: 40px;
				font-weight: bold;
				color: #1DC33C;
				line-height: 133px;
			}
		}
	}

	.buts {
		cursor: pointer;
		width: 202px;
		height: 43px;
		line-height: 43px;
		background: #F7B500;
		border-radius: 43px;
		text-align: center;
		margin: 30px auto;
		font-size: 18px;
		font-weight: 500;
		color: #FFFFFF;
	}
</style>
